/** @format */

export const Href: string = "#JavaScript";
//Dashboard
//ecommerce
export const ActivitiesTitle: string = "Activities";
export const ProductDelivery: string = "Product Delivery";
export const ActiveProjects: string = "Active Projects";
export const ProjectsOverviewTitle: string = "Projects Overview";
export const CalendarTitle: string = "Calendar";
export const ProjectsStatusTitle: string = "Projects Status";
export const ChatApplicationTitle: string = "Chat Application";
export const RecentProjectUpdateTitle: string = "Recent Project Update";
export const AvgEarnings: string = "Avg. Earnings";
export const DailyTaskTitle: string = "Daily Task";

//Dashboard
//default
export const SatisfactionRateTitle: string = "Satisfaction Rate";
export const RevenueIndustry: string = "Revenue by Industry";
export const TotalProfitTitle: string = "Total Profit";
export const EarningReportsTitle: string = "Earning Reports";
export const UpcomingTransaction: string = "Upcoming Transaction";
export const MembersStatistics: string = "Members Statistics";
export const TopReferralsPages: string = "Top Referrals Pages";
export const TotalTransactions: string = "Total Transactions";
export const Report: string = "Report";
export const RecentOrders: string = "Recent Orders";
export const SalesOverview: string = "Sales Overview";
export const RevenueOrder: string = "Revenue vs Order";
export const StockReportTitle: string = "Stock Report";
export const WeeklyVisitorTitle: string = "Weekly Visitors";
export const CustomerRateTitle: string = "Customer Rate";

//Maps
export const BasicMapTitle: string = "Basic Map";
export const MarkerMapTitle: string = "Marker Map";
export const PolygonsTitle: string = "Polygons";
export const PolylinesTitle: string = "Polylines";
export const LeafletMapTitle: string = "Leaflet Map";
export const WorldMapTitle: string = "Leaflet World Map";
export const UsaMapTitle: string = "Leaflet Usa Map";
export const IndiaMapTitle: string = "Leaflet India Map";
export const AustraliaMapTitle: string = "Leaflet Australia Map";

//Editor
export const JavascriptModeTitle: string = "Javascript Mode";
export const HTMLModeTitle: string = "Html Mode";
export const CssModeTitle: string = "Css Mode";
export const PhpModeTitle: string = "Php Mode";
export const StandardEditorTitle: string = "Standard Editor";
export const SnowThemeTitle: string = "Snow Theme";
export const BubbleThemeTitle: string = "Bubble Theme";

//Support Ticket
export const SupportTicketList: string = "Support Ticket List";
export const Profit: string = "Profit";
export const Loss: string = "Loss";

//auth
export const SignInAccount: string = "Sign in to account";
export const RememberPassword: string = "Remember password";
export const ForgotPassword: string = "Forgot password?";
export const SignInWith: string = "Or Sign in with";
export const TwitterLink: string = "Twitter";
export const FacebookLink: string = "Facebook";
export const DontHaveAccount: string = "Don't have account?";
export const CreateAccount: string = "Create Account";
export const CreateYourAccount: string = "Create your account";
export const YourName: string = "Your Name";
export const Agreewith: string = "Agree with";
export const PrivacyPolicy: string = "Privacy Policy";
export const Unlock: string = "UNLOCK";
export const EnterYourPassword: string = "Enter your Password";
export const ResetYourPassword: string = "Reset Your Password";
export const EnterYourMobileNumber: string = "Enter Your Mobile Number";
export const Resend: string = " Resend ";
export const EnterOtp: string = "Enter OTP";
export const CreateYourPassword: string = "Create Your Password";
export const NewPassword: string = "New Password";
export const RetypePassword: string = "Retype Password";
export const MAINTENANCE: string = "MAINTENANCE";
export const SignUpAccount: string = "Sign up to account";
export const EnterDetails: string = "Enter your email & password to login";
export const Finish: string = "Finish";
export const Phone: string = "phone";
export const Birthday: string = "Birthday:";

//Miscellaneous
//gallery
export const ImageGalleryTitle: string = "Image Gallery";
export const ImageGalleryDescriptionTitle: string =
  "Image Gallery with Description";
export const PortfolioTitle: string = "Portfolio Title";
export const MasonryGalleryTitle: string = "Masonry Gallery";
export const MasonryDescriptionTitle: string =
  "Masonry Gallery With Description";
export const ImageHoverEffectsTitle: string = "Image Hover Effects";
export const HoverEffect: string = "Hover Effect";

//blog
export const Comment: string = "Comment";
export const PostEditTitle: string = "Post Edit";
export const Title: string = "Title";
export const Type: string = "Type";
export const Category: string = "Category";
export const Content: string = "Content";
export const Discard: string = "Discard";

//Job search
export const JobFilter: string = "Job Filter";
export const ProductDesignerTitle: string = "Product Designer (UI/UX Designer)";
export const Apply: string = "Apply";
export const JobDescription: string = "Job Description";
export const SaveThisJob: string = "Save this job";
export const Share: string = "Share";
export const SimilarJobs: string = "Similar Jobs";
export const UIDesigner: string = "UI Designer";
export const PersonalDetailsTitle: string = "Personal Details";
export const FullName: string = "Full name";
export const BirthDate: string = "Birth Date";
export const RepeatPassword: string = "Repeat Password";
export const YourEducationTitle: string = "Your Education";
export const CollegeName: string = "College Name";
export const Period: string = "Period";
export const DegreeLevel: string = "Degree Level";
export const Specialization: string = "Specialization";
export const YourExperienceTitle: string = "Your Experience";
export const Position: string = "Position";
export const CompanyName: string = "Company Name";
export const UploadYourFiles: string = "Upload Your Files";
export const UploadCoverLetter: string = "Upload Cover Letter";
export const UploadYourCV: string = "Upload Your CV";
export const UploadRecommendations: string = "Upload Recommendations";

//Learning
export const LearningFilterTitle: string = "Learning filter";
export const FindCourse: string = "Find Course";
export const Filter: string = "Filter";
export const CategoriesTitle: string = "Categories";
export const UpcomingCoursesTitle: string = "Upcoming Courses";

//faq
export const QuickQuestionsTitle: string = "Quick Questions are answered";
export const SearchArticlesTitle: string = "Search Articles";
export const Navigation: string = "Navigation";
export const AskQuestion: string = "Ask Question";
export const LatestUpdatesTitle: string = "Latest Updates";
export const FeaturedTutorialsTitle: string = "Featured Tutorials";
export const LatestArticlesVideosTitle: string = "Latest Articles and Videos";

//Knowledgebase
export const BrowseArticlesTitle: string = "Browse articles by category";
export const BrowseArticlesHeader: string = "Browse Articles";
//table-components
export const UIComponentsTitle: string = "UI Components";
export const AlertTitle: string = "Alert";
export const ProgressbarTitle: string = "Progressbar";
export const CheckboxTitle: string = "Checkbox";
export const RadioButtonsTitle: string = "Radio Buttons";
export const Select: string = "Select";
export const BadgesTitle: string = "Badges";
export const TooltipTriggersTitle: string = "Tooltip Triggers";
export const SwitchTitle: string = "Switch";
export const DefaultButtonsTitle: string = "Default Button";
//data-tables
export const ZeroConfigurationTitle: string = "Zero Configuration";
export const StateSavingTableTitle: string = "State saving";
export const ScrollVerticalDynamicHeightTitle: string =
  "Scroll - vertical, dynamic height";
export const StockResultTitle: string = "Stock Result";
export const RowCreateCallbackTitle: string = "Row Create Callback";
export const AddRowsTitle: string = "Add rows";
export const AddNewRow: string = "Add new row";
export const ChildRowsTitle: string =
  "Child rows (show extra / detailed information)";
export const RowsSelectionAndDeletionTitle: string =
  "Row Selection And Deletion (Single Row)";
export const DeleteRow: string = "Delete Row";
export const CustomFilteringTitle: string = "Custom filtering - range search";
export const HtmlTableTitle: string = "HTML (DOM) Sourced Data";
export const AjaxSourcedDataTitle: string = "Ajax sourced data";
export const JavascriptSourcedDataTitle: string = "Javascript sourced data";
export const ServerSideProcessingTitle: string = "Server-side processing";

//pages sample
export const SampleCardTitle: string = "Sample Card";
//form-wizard2
export const CustomHorizontalTitle: string = "Custom horizontal wizard";
export const Continue: string = "Continue";
export const AadhaarNumber: string = "Aadhaar Number";
export const PAN: string = "PAN";
export const ChooseBanks: string = "Choose from these popular banks";
export const DescribeIssue: string = "If no, could you please describe?";
export const SuccessfullyCompleted: string = "Successfully Completed";
export const AccountType: string = "Select the type of account";
export const AccountName: string = "Account Name";
export const ProjectDescription: string =
  " Select a project and write a description for it";
export const ContactDetails: string = "Contact details";
export const OrganizationName: string = "Organization Name";
export const JoinOrganizationType: string = "Join organization type";
export const OrganizationDescription: string = "Organization description";
export const BusinessVerticalTitle: string = "Business vertical wizard";
export const CustomVerticalTitle: string = "Custom vertical wizard";
export const BusinessWizardTitle: string = "Business horizontal wizard";
//two-factor
export const TwoFactorAuthenticationTitle: string = "Two-factor authentication";
export const FactorAuthentication: string = "2 factor authentication";
export const Next: string = "Next";
export const EmailVerificationTitle: string = "Email verification";
export const Verify: string = "Verify";
export const VerificationCodeTitle: string = "Verification code";

//Tables
//Basic-table
export const BasicTableWithBorderTitle: string =
  "Basic Table With Border Bottom Color";
export const InverseTableTitle: string = "Inverse Table";
export const HoverableRowsTitle: string =
  "Hoverable Rows With Horizontal Border";
export const InverseTablePrimaryTitle: string =
  "Inverse Table with Primary background";
export const CaptionTitle: string = "Caption";
export const UserList: string = "List of users";
export const TableHeadOptionsTitle: string = "Table head options";
export const StripedRowInverseTableTitle: string =
  "Striped Row with Inverse Table";
export const BreckpointSpecificTitle: string = "Breckpoint Specific";
export const ResponsiveLightBackgroundTitle: string =
  "Responsive Tables With Light Background";
export const SizingTablesTitle: string = "Sizing Tables";
export const CustomColorHoverStrippedTitle: string =
  "Custom Table Color With Hover And Stripped";
export const DashedBorderTitle: string = "Dashed Border";
//clipboard
export const ClipBoardOnTextInputTitle: string = "Clipboard on text input";
export const Copy: string = "Copy";
export const Cut: string = "Cut";
export const ClipboardOnTextAreaTitle: string = "Clipboard on textarea";
export const ClipboardOnParagraphTitle: string = "Clipboard on paragraph";
export const ClipboardParagraphText: string = "Copy from paragraph";
export const CopyPortionParagraphTitle: string = "Copy portion from paragraph";
export const CopyHighlightedText: string = "Copy highlighted text";

//form-layout
//form-wizard1
export const NumberingWizardTitle: string = "Numbering wizard";
export const ConfirmPassword: string = "Confirm Password";
export const PlaceholderName: string = "Placeholder Name";
export const UploadDocumentation: string = "Upload Documentation";
export const AboveInformationCorrect: string =
  "All the above information is correct";
export const LinkedIn: string = "LinkedIn";
export const Github: string = "Git hub";
export const SelectState: string = "Select State";
export const GiveFeedback: string = "Give Feedback";
export const Congratulations: string = "Congratulations ";
export const StudentValidationFormTitle: string = "Student validation form";
export const Back: string = "Back";
export const AgreeTerms: string = "Agree to terms and conditions";
export const CardNumber: string = "Card Number";
export const Expiration: string = "Expiration(MM/YY)";
export const CVVNumber: string = "CVV Number";
export const Previous: string = "Previous";
export const Name: string = "Name";
export const AddProfile: string = "Add Profile";
export const PortfolioURL: string = " Portfolio URL";
export const ProjectDescriptionText: string = "project and write a description";
export const SocialLinks: string = " Social Links ";
export const Twitter: string = " Twitter";
export const VerticalValidationWizardTitle: string =
  "Vertical validation wizard";
export const ZipCode: string = "Zip Code";
export const ContactNumber: string = "Contact Number";
export const SelectPaymentMethod: string = "Select your payment method";
export const NetBanking: string = " NET BANKING";
export const SelectYourBank: string = " SELECT YOUR BANK";
export const Cvv: string = "CVV";
export const ShippingFormTitle: string = "Shipping form";
export const BillingInformation: string = "Billing Information ";
export const Address: string = "Address";
export const Country: string = "Country";
export const RememberMeNext: string = "Remember me for next time";
export const OtherNotes: string = "Other Notes";
export const ProceedToBack: string = "Proceed to back";
export const ProceedToNext: string = "Proceed to Next";
export const ShippingInformation: string = "Shipping Information";
export const SavedAddress: string = "Saved Address";
export const Information: string = "Information";
export const AddressType: string = "Address Type";
export const Save: string = "Save";
export const ShippingMethod: string = "Shipping Method";
export const PaymentInformation: string = "Payment Information";
export const CardHolder: string = "Card Holder";
export const OrderConfirmed: string = "Thank you! Your order is confirmed.";
export const CurrentCartTitle: string = "Current Cart";

//Form Widgets
//date-picker
export const DefaultCalendarTitle: string = "Default calendar";
export const ReactstrapCalendarTitle: string = "Reactstrap calendar";
export const DatePickerCardTitle: string = "Date picker";
export const DefaultDate: string = "Default Date";
export const HumanFriendly: string = "Human Friendly";
export const MinMaxValue: string = "Min-Max Value";
export const DisabledDates: string = "Disabled Dates";
export const MultipleDatesTitle: string = "Multiples Dates";
export const CustomizingConjunctionTitle: string = "Customizing Conjunction";
export const Range: string = "Range";
export const PreloadingDates: string = "Preloading Dates";
export const TimePickerTitle: string = "Time Picker";
export const HourPicker: string = "24-hour Time Picker";
export const TimePickerLimits: string = "Time Picker W/Limits";
export const PreloadingTime: string = "Preloading Time";
export const TimePickerRange: string = "TimePicker with Limited Time Range";
export const TimePickerMinMaxRange: string =
  "TimePicker with Min/Max Time Range";
export const DateWithTime: string = "Date With Time";
//touchspin
export const DefaultTouchspinTitle: string = "Default touchspin";
export const OutlinedTouchspinTitle: string = "Outlined touchspin";
export const IconsWithPrefixAndPostfixTitle: string =
  "Icons with prefix and postfix";
export const Pre: string = "Pre";
export const Post: string = "Post";
export const ButtonsWithPrefixPostfixTitle: string =
  "Buttons with prefix and postfix";
export const RoundedTouchspinTitle: string = "Rounded touchspin";
//switch
export const CustomSwitchTitle: string = "Custom switch";
export const DisabledOutlineSwitchTitle: string = "Disabled outline switch";
export const VariationOfSwitchesTitle: string = "Variation of switches";
//typeahead
export const BasicTypeaheadTitle: string = "Basic typeahead";
export const PrefetchTitle: string = "Prefetch";
export const BloodhoundTitle: string = "Bloodhound (Suggestion Engine)";
export const RemoteTypeaheadTitle: string = "Remote typeahead";
export const CustomTemplatesTitle: string = "Custom templates";
export const MultipleSectionsHeadersTitle: string =
  "Multiple sections with headers";
export const ScrollableDropdownMenuTitle: string = "Scrollable Dropdown Menu";
export const RTLSupportTitle: string = "RTL Support";
//Input Groups
export const ButtonAddonsTitle: string = "Button addons";
export const CustomFormsTitle: string = "Custom forms";
export const Options: string = "Options";
export const FavoriteColorsTitle: string = "Select Your Favorite Colors";
export const FavoriteChocolatesTitle: string =
  "Select Your Favorite Chocolates";
export const FavoriteItemsTitle: string = "Select Your Favorite Items";
export const CustomFileInputTitle: string = "Custom file input";
export const Upload: string = "Upload";
export const ButtonsWithDropdownsTitle: string = "Buttons with dropdowns";
export const SegmentedButtonsTitle: string = "Segmented buttons";
export const Success: string = "Success";
export const Secondary: string = "Secondary";
export const CheckboxesAndRadiosTitle: string = "Checkboxes and radios";
export const SizingTitle: string = "Sizing";
export const SmallInput: string = "Small";
export const DefaultInputText: string = "Default";
export const LargeInput: string = "Large";
export const MultipleInputsTitle: string = "Multiple inputs";
export const FirstAndLastName: string = "First and last name";
export const BasicInputGroupsTitle: string = "Basic input groups";
export const Basic: string = "Basic";
export const YourVanityUrl: string = "Your vanity URL";
export const Wrapping: string = "Wrapping";
export const VariationAddonsTitle: string = "Variation of addons";
export const LeftAddon = "Left Addon";
export const RightAddon = "Right Addon";
export const JointAddon = "Joint Addon";
export const LeftAndRightAddon = "Left & Right Addon";
export const SolidStyle = "Solid style";
export const FlatStyle = "Flat style";
export const RaiseStyle = "Raise style";

//Input Mask
export const InputMaskTitle: string = "Input Mask";
export const DateFormatTitle: string = "Date Format";
export const DateFormatType: string = "Date format type";
export const TimeFormatTitle: string = "Time Format";
export const TimeFormatType: string = "Time format type";
export const HourMonthType: string = "Hour/month type";
export const DefaultInputMaskTitle: string = "Default Input Mask";
export const Currency: string = "Currency";
export const Prefix: string = "Prefix";
export const Delimiter: string = "Delimiter";
export const PhoneNumber: string = "Phone Number";
export const Tailprefix: string = "Tailprefix";

//Mega Options
export const VariationRadioTitle: string = "Variation radio";
export const VariationCheckboxTitle: string = "Variation checkbox";
export const DefaultStyleTitle: string = "Default Style";
export const WithoutBordersStyleTitle: string = "Without borders style";
export const SolidBorderStyleTitle: string = "Solid border style";
export const OfferStyleBorderTitle: string = "Offer style border";
export const InlineStyleTitle: string = "Inline style";
export const VerticalStyleTitle: string = "Vertical style";
export const HorizontalStyleTitle: string = "Horizontal style";
export const MasterCard: string = "MasterCard";
export const Visa: string = "Visa";
//Forms
//Base-inputs
export const BasicFormTitle: string = "Basic form";
export const FloatingFormTitle: string = "Floating form";
export const SelectSizingTitle: string = "Select sizing";
export const FormControlSizingTitle: string = "Form control sizing";
export const FileInputTitle: string = "File input";
export const DefaultFileText: string = "Default file input example";
export const MultipleFileText: string = "Multiple files input example";
export const DisabledFileText: string = "Disabled file input example";
export const SmallFileText: string = "Small file input example";
export const LargeFileText: string = "Large file input example";
export const FlatInputStyleTitle: string = "Flat input style";
export const PleaseComments: string = "Please do comments";
export const RomanNumberTitle: string = "Select your favorite roman number";
export const MultiplePaintingTitle: string = "Select your multiple paintings";
export const BasicHtmlInputControlTitle: string = "Basic HTML input control";
export const CareerSelectTitle: string = "In which career are you interested?";
export const Placeholder: string = "Placeholder";
export const Number: string = "Number";
export const Telephone: string = "Telephone";
export const URL: string = "URL";
export const DateAndTime: string = "Date and time";
export const Date: string = "Date";
export const Month: string = "Month";
export const Week: string = "Week";
export const DatalistExampleTitle: string = "Datalist example";
export const Time: string = "Time";
export const ColorPicker: string = "Color picker";
export const MaximumLength: string = "Maximum Length";
export const StaticText: string = "Static Text";
export const StaticMagicalText: string = "Hello !... This is my magical text";
export const BasicFloatingInputControlTitle: string =
  "Basic floating input control";
export const ValidInput = "Valid input";
export const InputWithValue = "Input with value";
export const InvalidInput = "Invalid input";
export const OpenSelectMenu = "Open this select menu";
export const WorksWithSelects = "Works with selects";
export const InputGroupTitle = "Input group";
export const UsernameFeedback2 = "Please choose a username.";
export const Layout = "Layout";
export const Comments: string = "Comments";
export const EdgesInputStyleTitle: string = "Edges input style";
export const DefaultInput: string = "Default Input";
export const Male: string = "Male";
export const Female: string = "Female";
export const RaiseInputStyleTitle: string = "Raise input style";
export const PixelstrapThemeTitle: string =
  "Select Your Favorite Pixelstrap theme";
export const ColorSelectTitle: string = "Select the color you like below";

//checkbox & radio
export const DefaultCheckboxTitle: string = "Default checkbox";
export const Indeterminate: string = "Indeterminate";
export const IndeterminateCheckbox: string = "Indeterminate checkbox";
export const CustomCheckboxTitle: string = "Custom checkbox";
export const BorderedCheckboxTitle = "Bordered Checkbox";
export const PrimaryCheckbox = "Primary - checkbox-primary";
export const SecondaryCheckbox = "Secondary - checkbox-secondary";
export const SuccessCheckbox = "Success - checkbox-success";
export const IconCheckboxTitle = "Icon Checkbox";
export const FilledCheckboxTitle = "Filled Checkbox";
export const SuccessSolidCheckbox = "Success - checkbox-solid-Success";
export const PrimarySolidCheckbox = "Primary - checkbox-solid-Primary";
export const SecondarySolidCheckbox = "Secondary - checkbox-solid-Secondary";
export const DefaultRadioTitle = "Default radio";
export const CustomRadiosTitle = "Custom Radios";
export const DefaultCheckedRadio = "Default checked radio";
export const DisabledRadios = "Disabled Radios";
export const DisabledRadioSmall = "Disabled radio";
export const DisabledCheckedRadio = "Disabled checked radio";
export const RightRadios = "Right Radios";
export const ImagesCheckboxTitle = "Images with checkbox";
export const ImagesWithRadioTitle = "Images with radio";
export const BorderedRadioTitle = "Bordered Radio";
export const IconsRadioTitle = "Icons Radio";
export const FilledRadioTitle = "Filled Radio";
export const DefaultSwitchesTitle = "Default switches";
export const InlineInputTypesTitle = "Inline Input-types";
export const DrawInputTitle: string = "Draw Input Title";

export const InlineSwitchesTitle: string = "Inline Switches";
export const AnimatedButtonsTitle: string = "Animated buttons";
export const BasicRadioAndCheckboxTitle: string = "Basic radio and checkbox";
export const RadioToggleButtonsTitle: string = "Radio toggle buttons";
export const Checked: string = "Checked";
export const Radio: string = "Radio";
export const Disabled: string = "Disabled";
export const OutlinedCheckboxStylesTitle: string = "Outlined checkbox styles";
export const SingleToggle: string = "Single toggle";
export const CheckedSuccessRadio: string = "Checked success radio";
export const DarkRadio: string = "Dark radio";
//Charts
export const BasicAreaChartTitle: string = "Basic Area Chart";
export const AreaSpalineChartTitle: string = "Area Spaline Chart";
export const BarChartTitle: string = "Bar Chart";
export const ColumnChartTitle: string = "Column Chart";
export const BubbleChartTitle: string = "3d Bubble Chart";
export const SteplineChartTitle: string = "Stepline Chart";
export const PieChartTitle: string = "Pie Chart";
export const DonutChartTitle: string = "Donut Chart";
export const MixedChartTitle: string = "Mixed Chart";
export const CandlestickChartTitle: string = "Candlestick Chart";
export const RadarChartTitle: string = "Radar Chart";
export const RadialBarChartTitle: string = "Radial Bar Chart";

//Google chart
//Charts
export const AreaChartTitle1: string = "Area Chart 1";
export const AreaChartTitle2: string = "Area Chart 2";
export const ColumnChartTitle1: string = "Column Chart 1";
export const ColumnChartTitle2: string = "Column Chart 2";
export const GanttChartTitle: string = "Gantt Chart";
export const LineChartTitle: string = "Line Chart";
export const ComboChartTitle: string = "Combo Chart";
export const BarChart2Title: string = "Bar-chart2";
export const WordTreeTitle: string = "Word Tree";
export const PieChart: string = "Pie Chart";
export const ChartJsChartTitle: string = "ChartJS Chart";
export const LineGraphTitle: string = "Line Graph";
export const RadarGraphTitle: string = "Radar Graph";
export const DoughnutChartTitle: string = "Doughnut Chart";
export const PolarChartTitle: string = "Polar Chart";

//Forms
export const TooltipFormValidationTitle: string = "Tooltip form validation";
export const LooksGood: string = "Looks good!";
export const FirstName: string = "First name";
export const LastName: string = "Last name";
export const UserName: string = "Username";
export const City: string = "City";
export const Zip: string = "Zip";
export const SubmitForm: string = "Submit form";
export const BrowserDefaultsTitle: string = "Browser defaults";
export const EmailAddress: string = "Email address";
export const Password: string = "Password";
export const State: string = "State";
export const ChooseFile: string = "Choose file";
export const DescriptionLabel: string = "Description";
export const AgreePolicy: string =
  " By proceeding, you agree to the terms and conditions";
export const ConfirmationText: string =
  "Are you sure the above information is true";
export const PayMethodTitle: string = "Select your payment method";
export const Submit: string = "Submit";
export const ValidationFormTitle: string = "Validation Form";
//Creative Card
export const BorderLeftTitle: string = "Border Left";
export const BorderRightTitle: string = "Border Right";
export const BorderTopTitle: string = "Border Top";
export const BorderBottomTitle: string = "Border Bottom";
export const BorderPrimaryTitle: string = "Border Primary State";
export const BorderWarningTitle: string = "Border Warning State";
export const BorderSecondaryTitle: string = "Border Secondary State";
export const AbsoluteCard: string = "Absolute Card";

//Timeline
export const BasicTimelineTitle: string = "Basic Timeline";
export const HoverTimelineTitle: string = "Hovering Timeline";
export const HoverFresherText1: string = "Ofwrrior Company";
export const MollyBoake: string = "Molly Boake";
export const HoverMeetupText1: string = "US Meeting";
export const VariationTimelineTitle: string = "Variation Timeline";
export const HorizontalTimelineTitle: string = "Horizontal Timeline";
export const DesignerText: string = "Designer";
export const TimelineTitle: string = "Timeline";
export const AppIdeas: string = "app-ideas";
export const BlogBadge: string = "Blog";
export const AudioTesting: string = "Audio testing";
export const MeetUp: string = "Meet-up";
export const Resolutions: string = "Resolutions";

//Icons
export const FlagIconsTitle: string = "Flag Icons";
export const FontAwesomeIconTitle: string = "Font Awesome Icon";
export const IconsTitle: string = "Icons";
export const IcoIconTitle: string = "ICO Icon";
export const ThemifyIconTitle: string = "Themify Icon";
export const FeatherIconsTitle: string = "Feather Icons";
export const WhetherIconTitle: string = "Whether Icon";
export const WhetherIconsWithAnimations: string =
  "Whether Icons With Animations";

//Buttons
export const SquareButtonsTitle: string = "Square Buttons";
export const DefaultButtonTitle: string = "Default buttons";
export const ButtonSizesTitle: string = "Button Sizes";
export const OutlineButtonSizesTitle: string = "Outline Button Sizes";
export const RoundedButtonsTitle: string = "Rounded Buttons";
export const OutlineRoundedButtonsTitle: string = "Outline Rounded Buttons";
export const RoundedSizesTitle: string = "Rounded Sizes";
export const OutlineRoundedSizesTitle: string = "Outline Rounded Sizes";
export const DisabledButtonsTitle: string = "Disabled Buttons";
export const IconsButtonsTitle: string = "Icons Buttons";
export const ButtonGroupTitle: string = "Button Group";
export const BlockLevelButtonsTitle: string = "Block Level Buttons";
export const ButtonVariationsTitle: string = "Button Variations";
export const VerticalVariationTitle: string = "Vertical variation";
export const HorizontalVariationTitle: string = "Horizontal variation";
export const ButtonToolbarTitle: string = "Button toolbar";
export const BoldBorderOutlineButtonsTitle: string =
  "Bold Border Outline Buttons";
export const RadioCheckboxGroupTitle: string = "Radio and Checkbox Group";
export const RadioButtonTitle: string = "Radio Button";
export const CheckboxButtonTitle: string = "Checkbox";
export const GradientButtonsTitle: string = "Gradient Buttons";
//Breadcrumb
export const BreadcrumbTitle: string = "Breadcrumb";
export const DefaultBreadcrumbTitle: string = "Default Breadcrumb";
export const UiKits: string = "Ui Kits";
export const DividerBreadcrumbTitle: string = "Divider Breadcrumb";
export const Progress: string = "Progress";
export const WithIconBreadcrumbTitle: string = "With Icons Breadcrumb";
export const VariationBreadcrumbTitle: string = "Variation Of Breadcrumb";
export const HomeArrow: string = "Home -> ";
export const TablesArrow: string = " Tables -> ";
export const BootstrapArrow: string = " Bootstrap Tables -> ";
export const BasicTables: string = " Basic Tables";
export const ColoredBreadcrumbTitle: string = "Colored Breadcrumb";

//Range-slider
export const DefaultRangeTitle: string = "Default Range Slider";
export const NagativeRangeTitle: string = "Negative Values Slider";
export const DisabledSliderTitle: string = "Disabled Range Slider";
export const PointFormatedLabelTitle: string = "Point Formated Label";
export const PostfixFormatedLabelTitle: string = "Postfix Formated Label";
export const DraggableTitle: string = "Draggable Range Slider";

//Image-cropper
export const ImageCropperTitle: string = "Image Cropper";

//Basic Card
export const BasicCardTitle: string = "Basic Card";
export const FlatCardTitle: string = "Flat Card";
export const WithoutShadowTitle: string = "Without shadow Card";
export const IconHeadingTitle: string = "Icon In Heading";
export const DarkCardTitle: string = "Dark Color Card";
export const CardFooterText: string = "Card Footer";
export const InfoColorHeaderTitle: string = "Info Color Header";
export const InfoColorBodyTitle: string = "Info Color Body";
export const InfoColorFooterTitle: string = "Info Color Footer";
export const WebDesignerText: string = "Web Designer";
export const WebDeveloper: string = "Web Developer";
export const YuriTheme: string = "Yuri Theme";
//Rating
export const RatingBars: string = "1 to 10 Rating Bar";
export const MovieRatingBar: string = "Movie Rating Bar";
export const SquareRatingBar: string = "Square Rating Bar";
export const PillRatingBar: string = "Pill Rating Bar";
export const ReversedRatingBar: string = "Reversed Rating Bar";
export const StarRatingBar: string = "Star Rating Bar";
export const HalfStarRatingBar: string = "Half Star Rating Bar";
export const ThumbUpDownRate: string = "Thumb Up/Down Rating Bar";
export const HeartRatingBar: string = "Heart Rating Bar";

//Dropzone
export const DefaultDropzoneTitle: string = "Default File Upload";
export const ImagePreviewTitle: string = "Image Preview";
export const SingleFileuploadTitle: string = "Single File Upload";
export const MultiFileUploadTitle: string = "Multi File Upload";

//Tour
export const Email: string = "Email";
export const BOD: string = "BOD";
export const WilliamJennings: string = "William C. Jennings";
export const WebDesigner: string = "Web designer";
export const ContactUs: string = "Contact us";
export const Location: string = "Location";
export const ReadMore: string = "Read more";

//Sweetalert
export const BasicAlertTitle: string = "Basic Example";
export const ClickIt: string = "Click it!";
export const TitleWithTextTitle: string = "Title With A Text Under";
export const Surprise: string = "Surprise!";
export const InfoAlertTitle: string = "Info Alert";
export const Informational: string = "Informational";
export const WarningAlertTitle: string = "Warning Alert";
export const Warning: string = "Warning";
export const PikachuAlertTitle: string = "Pikachu Alert";
export const Pikachu: string = "Pikachu";
export const QuestionAlertTitle: string = "Questions Alert";
export const QuestionsState: string = "Questions state";
export const UserNameAlertTitle: string = "Username Alert";
export const Username: string = "Username";
export const SuccessMessageTitle: string = "Success Message";
export const LoginSuccessfully: string = "Login successfully";
export const DangerAlertTitle: string = "Danger Alert";
export const DangerMode: string = "Danger mode";
export const WarningModeTitle: string = "Warning Mode";
export const AlertMode: string = "Alert mode";
export const AutoCloseAlertTitle: string = "Auto Close Timer";
export const Timer: string = "Timer";
export const MovieMode: string = "Movie mode";
export const MovieAlertTitle: string = "AJAX Request Movie";

//Owl Carousel
export const SlidesOnlyTitle: string = "Slides Only";
export const WithControlsTitle: string = "With Controls";
export const AutoPlayVariantTitle: string = "Auto Play Variant";
export const MouseOverTitle: string = "Mouse Wheel Variant";
export const WithIndicatorsTitle: string = "With Indicators";
export const WithCaptionTitle: string = "With Captions";
export const CrossFadeTitle: string = "Cross-Fade";
export const IndividualCarouselTitle: string =
  "Individual Carousel-Item Interval";
export const DisableTouchSwipingTitle: string = "Disable Touch Swiping";
export const DarkVariantTitle: string = "Dark Variant";

//Ribbons
export const LeftSideRibbonsTitle: string = "Variations Of Left Ribbons";
export const RightSideRibbonTitle: string = "Variations Of Right Ribbons";

//Pagination
export const DefaultPaginationTitle: string = "Default Pagination";
export const ActiveDisablePageTitle: string =
  "Pagination With Active And Disabled";
export const IconPaginationTitle: string = "Pagination With Icons";
export const RoundedPaginationTitle: string = "Rounded Pagination";
export const PaginationAlignTitle: string = "Pagination Alignment";
export const PaginationSizeTitle: string = "Pagination Sizing";
export const CopyText: string = "Copy text";

//Bonus Ui
export const ScrollableTitle: string = "Scrollable";
export const CustomScrollbarTitle: string = "Custom Scrollbar";
export const SmallSizeScrollTitle: string = "Small Size Scrollbar";
export const SmallScrollText: string = "Solution for Business Transformation";
export const BadgesScrollbarTitle: string = "Badges Scrollbar";
export const ProfileScrollableTitle: string = "Profile Scrollable";
export const ScrollableContentTitle: string = "Scrollable Content";
export const HorizontalScrollbarTitle: string = "Horizontal Scrollbar";
export const BothSideScrollbarTitle: string = "Both Side Visible Scrollbar";

//Tree View
export const BasicTreeTitle: string = "Basic Tree";
export const DisabledTreeTitle: string = "Disabled Tree";

//Toasts
export const LiveToastTitle: string = "Live Toast";
export const TopRightToastTitle: string = "Top-right toast";
export const BottomRightToastTitle: string = "Bottom-right toast";
export const TopLeftToastTitle: string = "Top-left toast";
export const BottomLeftToastTitle: string = "Bottom-left toast";
export const ColorsSchemesTitle: string = "Colors Schemes";
export const StackingToastsTitle: string = "Stacking Toasts";
export const TranslucentToastsTitle: string = "Translucent Toasts";
export const DefaultToastTitle: string = "Default Toast";
export const UniqueToastTitle: string = "Unique Toast";
export const ToastPlacementTitle: string = "Toast Placement";

//Bootstrap Tabs
export const SimpleTabTitle: string = "Simple tabs";
export const Home: string = "Home";
export const Contact: string = "Contact";
export const Profile: string = "Profile";
export const IconTabsTitle: string = "Icons With Tabs";
export const VerticalTabTitle: string = "Vertical Tabs";
export const Components: string = "Components";
export const Inbox: string = "Inbox";
export const Settings: string = "Settings";
export const Pages: string = "Pages";
export const PillsTabTitle: string = "Pills tabs";
export const AboutUs: string = "About us";
export const Blog: string = "Blog";
export const JustifyTabTitle: string = "Justify Tabs";
export const AdminProfile: string = "Admin Profiles For New Employees:";
export const IotDeveloper: string = "IOT developer";
export const MaterialLeftStyleTabTitle: string = "Material Style Left Tabs";
export const MaterialStyleTabTitle: string = "Material Style Tabs";
export const User: string = "User";
export const Description: string = "Description";
export const Review: string = "Review";
export const BorderTabsTitle: string = "Border Tabs";

//Lists
export const DefaultListTitle: string = "Default lists";
export const LogoDesign: string = "Logo Design";
export const WebDesignDevelop: string = "Web Design & Development ";
export const ECommerce: string = "E-Commerce";
export const SEO: string = "SEO";
export const ActiveListTitle: string = "Active lists";
export const WowAnimations: string = "Wow Animations";
export const ApexCharts: string = "Apex Charts";
export const StarterKits: string = "Starter Kits";
export const FlushListTitle: string = "Flush lists";
export const PRODUCT: string = "PRODUCT";
export const PRODUCTDETAILS: string = "PRODUCT DETAILS ";
export const CART: string = "CART ";
export const CHECKOUT: string = "CHECKOUT";
export const ContextualClassTitle: string = "Contextual classes";
export const HorizontalListTitle: string = "Horizontal lists";
export const CustomListTitle: string = "Custom content lists";
export const ListWithCheckboxTitle: string = "Lists With Checkbox";
export const ListWithRadioTitle: string = "Lists With Radios";
export const ListWithNumberTitle: string = "Lists With Numbers";
export const JsBehaviorTitle: string = "JavaScript Behavior";
export const NumberedBadgeListTitle: string = "Numbered & Badge Lists";
export const DisableListTitle: string = "Disabled lists";
export const ScrollableListTitle: string = "Scrollable lists";
//Dropdown
export const DropdownTitle: string = "Dropdown";
export const BasicDropdownTitle: string = "Basic Dropdown";
export const Dashboard: string = "Dashboard";
export const RoundedDropdownTitle: string = "Rounded Dropdown";
export const Primary: string = "Primary";
export const SplitDropdownTitle: string = "Split Dropdown";
export const Widgets: string = "Widgets";
export const HeadingDropdownTitle: string = "Heading Dropdown";
export const Party: string = "Party";
export const DropdownWithInputTitle: string = "With Input Type";
export const Inputs: string = "Inputs";
export const DarkNight: string = "Dark Night";
export const DarkDropdownTitle: string = "Dark Dropdown";
export const UniqueDropdownTitle: string = "Unique Dropdown";
export const DropdownFormText: string = "Dropdown form";
export const RememberMe: string = "Remember me";
export const SignIn: string = "Sign in";
export const Text: string = "Text";
export const JustifyContentTitle: string = "Justify Content";
export const TextLeft: string = "Text-left";
export const AlignmentsTitle: string = "Alignments";
export const WarningTop: string = "Warning top";
export const HelperCardTitle: string = "Helper Card";
export const DividerDropdownTitle: string = "Divider Dropdown";
export const DropdownSizingTitle: string = "Dropdown Sizing";
export const LargeButton: string = "Large button";
export const SmallButton: string = "Small button";

//Accordion
export const SimpleAccordionTitle: string = "Simple Accordion";
export const WebDesignersDo: string = "What do web designers do?";
export const UseWebDesign: string = "What is the use of web design?";
export const ElementsWebDesign: string = "What are the elements of web design?";
export const FlushAccordionTitle: string = "Flush Accordion";
export const MultipleCollapseTitle: string = "Multiple Collapse Accordion";
export const ToggleFirst: string = "Toggle first element";
export const ToggleSecond: string = "Toggle second element";
export const ToggleBoth: string = "Toggle both elements";
export const IconAccordionTitle: string = "With Icons Accordion";
export const OutlineAccordionTitle: string = "Outline Accordion";
export const HorizontalAccordionTitle: string = "Horizontal Accordion";
export const ToggleWidthCollapse: string = "Toggle width collapse";
export const CollapesAccordionTitle: string = "Collapse Accordion";
export const LinkWithHref: string = "Link with href";
export const ButtonWithEvent: string = "Button with data-bs-target";

//Alert
export const LinkColorTitle: string = "Link Color In Dark Theme";
export const LinkLightColorTitle: string = "Link Color In Light Theme";
export const OutlineAlertTitle: string = "Outline Dark And Light Alerts";
export const AlertWithIconsTitle: string = "Alerts With Icons and Text Actions";
export const DismissingDarkAlertTitle: string = "Dismissing Dark Alerts";
export const DismissingLightAlertTitle: string = "Dismissing Light Alerts";
export const LiveAlertTitle: string = "Live Alert";
export const ShowLiveAlert: string = "Show live alert";
export const LiveAlertText: string = "Nice, you triggered this alert message!";
export const LeftBorderAlertTitle: string = "Left Border Alert";
export const AdditionalAlertTitle: string = "Additional content";

//Popover
export const BasicPopoverTitle: string = "Basic Popover";
export const HurryUp: string = "Hurry Up!";
export const PopoverDirectionTitle: string = "Popover Direction";
export const PopoverOnTop: string = "Popover on top";
export const PopoverOffsetTitle: string = "Popover Offset";
export const Popoveroffset50: string = "Popover offset 50";
export const Popovertitle: string = "Popover title";
export const PopoveroffsetDash50: string = "Popover offset -50";
export const PopoverOnLeft: string = "Popover On Left";

//Tooltip
export const BasicTooltipTitle: string = "Basic Tooltip";
export const BasicTooltipText: string = "It's magic please hover me... ";
export const SurpriseText: string = "Surprise!!! Thank you for hovering...";
export const InlineTooltipContent: string = "Inline Tooltip Content";
export const ColoredTooltipTitle: string = "Colored Tooltip";
export const TooltipDirectionTitle: string = "Tooltip Directions";
export const TooltipOn: string = "Tooltip on ";
export const HtmlTooltipTitle: string = "HTML Elements With Hover Effect";
export const FilledTooltipTitle: string = "Filled Tooltip";
//Modal
export const BasicModalTitle: string = "Basic Modal";
export const Close: string = "Close";
export const SaveChanges: string = "Save Changes";
export const Simple: string = "Simple";
export const Upto: string = "Up to ";
export const SimpleText: string = ", Hurry Up Online Shopping";
export const ExploreMore: string = "Explore More";
export const ScrollingContent: string = "Scrolling content";
export const WedDesigner: string = "Wed Designer";
export const UXDesigner: string = "UX Designer";
export const TooltipsPopovers: string = "Tooltips and popovers";
export const PopoverModal: string = "Popover in a modal";
export const TooltipButtonText: string = "this is amazing content";
export const TooltipsModal: string = "Tooltips in a modal";
export const OpenModalYuri: string = "Open modal for yuri";
export const YuriSignUp: string = "YURI SIGN-UP";
export const SignUp: string = "Sign Up";
export const SizeModalTitle: string = "Sizes Modal";
export const FullScreenModal: string = "Full Screen Modal";
export const FullscreenModal: string = "Fullscreen modal";
export const ExtraLargeModal: string = "Extra large Modal";
export const LargeModalButton: string = "Large Modal";
export const SmallModalButton: string = "Small Modal";
export const StartYourGoals: string = "Start with your goals";
export const FullscreenModalTitle: string = "Fullscreen Modal";
export const WebDesign: string = "Web Design";
export const FullscreenBelowSm: string = "Fullscreen below sm";
export const FullscreenBelowMd: string = "Fullscreen below md";
export const FullscreenBelowLg: string = "Fullscreen below lg";
export const FullscreenBelowXl: string = "Fullscreen below xl";
export const FullscreenBelowXxl: string = "Fullscreen below xxl";
export const VerticallyCentered: string = "Vertically centered";
export const CenteredModalTitle: string = "Centered modal";
export const CenteredError: string = "Ohh! Something went wrong!";
export const ToggleModalTitle: string = "Toggle between modals";
export const OpenFirstModal: string = "Open first modal";
export const ConnectNewAccount: string = "Connect new account";
export const Cancel: string = "Cancel";
export const NotMember: string = " Not a member?";
export const Register: string = "Register";
export const YesLogout: string = "Yes, Log out";
export const LogoutText: string = "Are you sure want to logout this dashboard?";
export const AlreadyLeaving: string = "Already leaving??";
export const StaticModalTitle: string = "Static Backdrop Modal";
export const StaticBackdropModal: string = "Static backdrop modal";
export const YuriLogin: string = "Yuri Login";
export const CheckMeOut: string = "Check me out";
export const CustomModalsTitle: string = "Yuri custom modals";
export const ClickOut: string = "Click Out";
export const Modal1Text: string = "Modal 1 - ";
export const Modal2text: string = "Modal 2 - ";
export const Modal3Text: string = "Modal 3 - ";
export const ResultModal: string = "Result Modal";
export const ProfileModal: string = "Profile Modal";
export const BalanceModal: string = "Balance Modal";
export const BrooklynSimmons: string = "Brooklyn Simmons";
export const BrooklynSimmonEmail: string = "@brookly.simmons";
export const YourBalance: string = "Your Balance";
export const YourTotalBalance = "768,987.90";
export const CashBackText: string = "Cash Back";
export const InvestmentConstant: string = "Investment";

// Grid
export const GridOptionsTitle: string = "GridOptions";
export const GridBehavior: string = "Grid behavior";
export const HorizontalTimes: string = "Horizontal at all times";
export const CollapsedToStart: string =
  "Collapsed to start, horizontal above breakpoints";
export const MaxContainerWidth: string = "Max container width";
export const None: string = "None (auto)";
export const Px540: string = "540px";
export const Px720: string = "720px";
export const Px960: string = "960px";
export const Px1140: string = "1140px";
export const Px1320: string = "1320px";
export const ClassPrefix: string = "Class prefix";
export const Col: string = ".col-";
export const Colsm: string = ".col-sm-";
export const Colmd: string = ".col-md-";
export const Collg: string = ".col-lg-";
export const Colxl: string = ".col-xl-";
export const Colxxl: string = ".col-xxl-";
export const OfColumns: string = "# of columns";
export const GutterWidth: string = "Gutter width";
export const GutterWidthNo: string = "1.5rem (.75rem on left and right)";
export const Nestable: string = "Nestable";
export const Yes: string = "Yes";
export const Offsets: string = "Offsets";
export const ColumnOrdering: string = "Column ordering";
export const GridColumnTitle: string = "Grid for column";
export const VerticalAlignmentTitle: string = "Vertical alignment";
export const Class: string = "Class";
export const ValueClass: string = "Value of the class";
export const VerticalClass: string = ".align-items-*";
export const VerticalPosition: string =
  " start / center / end / baseline / stretch";
export const HorizontalAlignmentTitle: string = "Horizontal alignment";
export const HorizontalClass: string = ".justify-content-*";
export const HorizontalPosition: string =
  "start / center / end / around / between";
export const NestingTitle: string = "Nesting";
export const OrderTitle: string = "Order";
export const OrderClass: string = ".order-*";
export const OrderPosition: string = " first / 2 / 3 / 4 / 5 / last";
export const OffSetTitle: string = "Offset";
export const OffSetClass: string = ".offset-*";
export const OffSetStep: string = " 1 / 2 / ... / 11 / 12";

//Tag & Pills
export const BadgesContextualTitle: string = "Badges Contextual Variations";
export const PillsContextualTitle: string = "Pills Contextual Variations";
export const NumberOfBadge: string = "Number of Badge";
export const NumberOfPills: string = "Number of Pills Tags";
export const BadgeIcons: string = "Badge Tags With Icons";
export const PillsWithIcons: string = "Rounded Pills With Icons";
export const BadgeHeadingsExample: string = "Badge Headings Example";
export const BadgeHeadingText: string = "Badge Heading";
export const Latest: string = "Latest";
export const Trending: string = "Trending";
export const Login: string = "Login";
export const BadgesPartButtons: string = "Badges As Part Buttons";

//Progress
export const BasicProgressBars: string = "Basic Progress Bars";
export const ProgressStriped: string = "Progress Bars Striped";
export const ProgressAnimated: string = "Progress Bars animated";
export const MultipleBarsTitle: string = "Multiple bars";
export const ProgressWithNumberTitle: string = "Progress With Number Steps";
export const CustomProgressTitle: string = "Custom Progress Bars";
export const SmallProgressTitle: string = "Small Progress Bars";
export const LargeProgressTitle: string = "Large Progress Bars";
export const CustomHeightProgressTitle: string = "Custom Height Progress Bars";
//layout
export const BasilAhmad: string = "Basil Ahmad";
export const Pinned: string = "Pinned";
export const Emptysearch: string = "Opps!! There are no result found.";
export const Notifications: string = "Notifications";
export const CheckAll: string = "Check all";
export const JaneCooper: string = "Jane Cooper";
export const Cart: string = "Cart";
export const OrderTotal: string = "Order Total :";
export const Gotoyourcart: string = "Go to your cart";
export const Checkout: string = "Checkout";
export const EmptyCart: string = "Oops! Your cart empty!!!";

//ui-kits
//Typography
export const HeadingsTitle: string = "Headings";
export const Rem1375: string = "1.375rem";
export const Rem1125: string = "1.125rem";
export const Rem0938: string = "0.938rem";
export const Rem0875: string = "0.875rem";
export const Rem125: string = "1.25rem";
export const Rem1: string = "1rem";
export const H1Tag: string = "<h1></h1>";
export const H2Tag: string = "<h2></h2>";
export const H3Tag: string = "<h3></h3>";
export const H4Tag: string = "<h4></h4>";
export const H5Tag: string = "<h5></h5>";
export const H6Tag: string = "<h6></h6>";
export const Heading1MEGA: string = " Heading 1 (MEGA)";
export const Heading2XL: string = " Heading 2 (XL)";
export const Heading3LARGE: string = "Heading 3 (LARGE)";
export const Heading4MEDIUM: string = "Heading 4 (MEDIUM)";
export const Heading5SMALL: string = "Heading 5 (SMALL)";
export const Heading6: string = "Heading 6";
export const ColoredHeadingTitle: string = "Colored headings";
export const Heading1: string = "Heading 1";
export const SubHeading: string = " Sub Heading";
export const FontWeightTitle: string = "Font weight";
export const Bolder: string = " You can set bolder font weight Heading 1 using";
export const BoldFont: string = " You can set bold font weight Heading 2 using";
export const MediumBold: string =
  "You can set medium font weight Heading 3 using";
export const NormalFont: string =
  "You can set normal font weight Heading 4 using";
export const LightFont: string =
  "You can set light font weight Heading 5 using";
export const fw700: string = "f-w-700";
export const fw600: string = "f-w-600";
export const fw500: string = "f-w-500";
export const fw400: string = "f-w-400";
export const fw300: string = "f-w-300";
export const ListingTypography: string = "Listing Typography";
export const UnorderListTitle: string = "Unorder list";
export const OrderListTitle: string = "Order list";
export const UIKits: string = "Ui Kits";
export const BonusUi: string = "Bonus Ui";
export const Animations: string = "Animations";
export const Typography: string = "Typography";
export const Avatars: string = "Avatars";
export const Grid: string = "Grid";
export const TagPills: string = "Tag & pills";
export const Alert: string = "Alert";
export const Dropdown: string = "Dropdown";
export const Tabs: string = "Tabs";
export const Accordion: string = "Accordion";
export const DescriptionListTitle: string = "Description list";

//avatars
export const Sizes: string = "Sizes";
export const StatusIndicatorTitle: string = "Status Indicator";
export const ShapesTitle: string = "Shapes";
export const RatioTitle: string = "Ratio";
export const GroupingTitle: string = "Grouping";

//Helper Classes
export const BorderStylesTitle: string = "Styles in borders";
export const CustomBorderTitle: string = "Custom border-radius class";
export const BorderColorTitle: string = "Border color";
export const BorderWidthTitle: string = "Border-width";
export const TextColorsTitle: string = "Text colors";
export const BordersAndDisplaysTitle: string = "Borders and displays";
export const AdditiveBorderTitle: string = "Additive border";
export const SubtractiveBorderTitle: string = "Subtractive border";
export const AdditiveRadiusTitle: string = "Additive Radius";
export const BackgroundColorsTitle: string = "Background Colors";
export const DarkBackgroundTitle: string = "Dark background";
export const LightBackgroundsTitle: string = "Light backgrounds";
export const ExtendedBackgroundTitle: string = "Extended background colors";
export const LightCard: string = ".light-card";
export const LightBackground: string = ".light-background";
export const ImageSizeTitle: string = "Image size";
export const FontStyleTitle: string = "Font-style";
export const FontSizeTitle: string = "Font size";
export const TextColorsBig: string = "Text Colors";
export const PaddingTitle: string = "Padding";
export const OneSidePaddingTitle: string = "Only one side padding";
export const MarginTitle: string = "Margin";
export const OneSideMarginTitle: string = "Only one side margin";
export const FontSizeText: string = "Font-size";
export const DisplayHeadingTitle: string = "Display headings";
export const Display: string = "Display";
export const InlineTextElementsTitle: string = "Inline text elements";
export const TextColorTitle: string = "Text Color";
export const BlockquotesTitle: string = "Blockquotes";

//Theme customizer
export const ConfigurationTitle: string = "Configuration";
export const CopyTextButton: string = "Copy Text";
export const LayoutTypeTitle: string = "Layout Type";
export const SidebarTypeTitle: string = "Sidebar Type";
export const SidebarIconTitle: string = "Sidebar Icon";
export const UnlimitedColorTitle: string = "Unlimited Color";
export const ApplyButton: string = "Apply";
export const LightLayoutTitle: string = "Light layout";
export const DarkLayoutTitle: string = "Dark layout";
export const MixLayoutTitle: string = "Mix Layout";
//Calendar
export const CalendarFilter: string = "calendar filter";
export const DraggableEventsTitle: string = "Draggable Events";
export const RemoveAfterDrop: string = "remove after drop";

//Social App
//Contacts
export const ContactFilter: string = "contact filter";
export const OrgenizationTitle: string = "Organization";
export const FollowUp: string = "Follow Up";
export const Ideas: string = "Ideas";
export const Personal: string = "Personal";
export const ContactsTitle: string = "Contacts";
export const EditMoreInformation: string = "Edit more information";
export const PrintPreview: string = "Print Preview";

//Tasks
export const TaskFilter: string = "task filter";
export const NewTaskTitle: string = "New Task";
export const TaskTitleLabel: string = "Task Title";
export const SubTaskTitle: string = "Sub task";
export const TodayTasks: string = "Today's Tasks";
export const DelayedTasks: string = "Delayed Tasks";
export const UpcomingTasks: string = "Upcoming Tasks";
export const ThisWeekTasks: string = "This week tasks";
export const ThisMonthTasks: string = "This month tasks";
export const AssignedToMe: string = "Assigned to me";
export const MyTasks: string = "My tasks";
//Users-edit
export const MyProfileTitle: string = "My Profile";
export const MutualFriendsTitle: string = "Mutual Friends";
export const ActivityFeedTitle: string = "Activity Feed";
export const ProfileIntroTitle: string = "Profile Intro";
export const Followers: string = "Followers";
export const FollowingsTitle: string = "Followings";
export const LatestPhotosTitle: string = "Latest Photos";
export const FriendsTitle: string = "Friends";
export const PepoleKnownTitle: string = "Pepole You May Know";
export const ViewedProfileTitle: string = "Viewed Your Profile";
export const ActivityLogTitle: string = "Activity Log";
//Users-edit
export const Bio: string = "Bio";
export const Website: string = "Website";
export const EditProfileTitle: string = "Edit Profile";
export const Company: string = "Company";
export const AboutMe: string = "About Me";
export const UpdateProfile: string = "Update Profile";
export const AddProjectsAndUploadTitle: string = "Add projects and Upload";

//Bookmark
export const BookmarkFilter: string = "bookmark filter";
export const NewBookmark: string = "New Bookmark";
export const AddBookmark: string = "Add Bookmark";
export const WebUrl: string = "Web Url";
export const Group: string = "Group";
export const Collection: string = "Collection";
export const CreateTag: string = "Create Tag";
export const TagName: string = "Tag Name";
export const TagColor: string = "Tag color";
export const CreatedByMe: string = "Created by me";
export const SharedWithMe: string = "Shared with me";
export const MyBookmark: string = "My bookmark";
export const Notification: string = "notification";
export const Draw: string = "Draw";
export const ShortCodes: string = "ShortCodes";

export const Favourites: string = "Favourites";
export const Important: string = "Important";
export const Organization: string = "Organization";
export const Newsletter: string = "Newsletter";
export const Business: string = "Business";
export const Holidays: string = "Holidays";
export const EditBookmark: string = "Edit Bookmark";

//Todo
export const ToDoFilter: string = "To Do filter";
export const ToDoList: string = "To Do List";
export const ToDoTitle: string = "To-Do";
//Letter box
export const EmailFilter: string = "email filter";
export const ComposeEmail: string = "Compose Email";
export const AddLabel: string = "Add Label";
export const ComposeMessage: string = "Compose Message";
export const SaveDraft: string = "Save as draft";
export const Send: string = "Send";
//Applications
//Ecommerce
//payment-details
export const Dollar: string = "$";
export const CreditCardTitle: string = "Credit Card";
export const DebitCardTitle: string = "Debit Card";
export const CodTitle: string = "COD";
export const EmiTitle: string = "EMI";
export const NetBankingTitle: string = "Net Banking";

//Order history
export const DatatableOrderHistoryTitle: string = "Order History";
//Cart
export const CartTitle: string = "Cart";
//Ecommerce
//Wishlist
export const WishlistTitle: string = "Wishlist";
//checkout
export const BillingDetails: string = "Billing Details";
export const PlaceOrder: string = "Place Order";
export const TownCity: string = "Town/City";
export const StateCountry: string = "State/Country";
export const PostalCode: string = "Postal Code";
//pricing
export const BecomeMemberTitle: string = "Become Member";
export const SimplePricingTitle: string = "Simple Pricing Card";
export const Purchase: string = "Purchase";
//Add-product
export const ProductForm: string = "Product Form";
export const AddProducts: string = "Add Products";
export const ProductTitleLabel: string = "Product Title";
export const AddCategory: string = "Add Category";
export const CreateNewCategory: string = "Create New Category";
export const CategoryName: string = "Category Name";
export const Add: string = "Add";
export const PublishStatus: string = "Publish Status";
export const PublishDateTime: string = "Publish Date & Time";
export const TooltipLabelText: string = "Types of product discount";
export const InitialCost: string = "Initial cost";
export const SellingPriceText: string = "Selling price";
export const ChooseYourCurrency: string = "Choose your currency";
export const ProductStocks: string = "Product stocks";
export const InventoryText: string = "Inventory";
export const AdditionalOptionText: string = "Additional Options";
export const ShippingText: string = "Shipping";
export const StockAvailability: string = "Stock Availability";
export const LowStock: string = "Low Stock";
export const Sku: string = "SKU";
export const StockQuantity: string = "Stock Quantity";
export const RestockDate: string = "Restock Date";
export const PreOrder: string = "Pre-Order";
export const AllowBackorders: string = "Allow Backorders";
export const DigitalProduct: string = "This is a digital Product";
export const AdditionalTagTitle: string = "Additional Tag Title";
export const SpecificTags: string = "Specific Tags";
export const OrderPickupLabel: string = "Where can I pick up my order?";
export const WeightLabel: string = "Weight (kg)";
export const DimensionsLabel: string = "Dimensions";
export const ShippingClass: string = "Shipping Class";

//Product
export const STEP = 10;
export const MIN = 25;
export const MAX = 100;
//Widgets
//chart
export const MonthlyHistoryTitle: string = "Monthly History";
export const SkillStatusTitle: string = "Skill Status";
export const OrderStatusTitle: string = "Order Status";
export const LiveProductsTitle: string = "Live Products";
export const TurnOverTitle: string = "Turn over";
export const StockMarketTitle: string = "Stock Market";

//Application
//Project
export const All: string = "All";
export const Doing: string = "Doing";
export const Done: string = "Done";
export const CreateNewProject: string = "Create New Project";
export const ProjectTitleLabel: string = "Project Title";
export const ClientName: string = "Client name";
export const ProjectRate: string = "Project Rate";
export const ProjectType: string = "Project Type";
export const Hourly: string = "Hourly";
export const FixPrice: string = "Fix price";
export const Priority: string = "Priority";
export const Low: string = "Low";
export const Medium: string = "Medium";
export const High: string = "High";
export const Urgent: string = "Urgent";
export const ProjectSize: string = "Project Size";
export const Small: string = "Small";
export const Big: string = "Big";
export const StartingDate: string = "Starting date";
export const EndingDate: string = "Ending date";
export const EnterSomeDetails: string = "Enter some Details";
export const UploadProjectFile: string = "Upload project file";

//File manager
export const FileFilter: string = "file filter";
